import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function postContact(data) {
  const res = await api.post("/contact", data);
  return res.data;
}

export async function postMembership(data) {
  const res = await api.post("/membership", data);
  return res.data;
}

export async function postVolunteer(data) {
  const res = await api.post("/volunteer", data);
  return res.data;
}

export async function postPartner(data) {
  const res = await api.post("/partner", data);
  return res.data;
}

export async function createDonationCheckout(data) {
  const res = await api.post("/donations/checkout", data);
  return res.data;
}

export async function getDonationStatus(sessionId) {
  const res = await api.get(`/donations/status/${sessionId}`);
  return res.data;
}
